import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=48e3f064&scoped=true"
import script from "./user-edit.vue?vue&type=script&lang=js"
export * from "./user-edit.vue?vue&type=script&lang=js"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=48e3f064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3f064",
  null
  
)

export default component.exports